import { H7 } from 'foundations-components/transitional/components/H7';
import FormattedMessage from 'I18n/components/FormattedMessage';
import { LoadingSpinner } from 'foundations-components/transitional/components/LoadingSpinner';
import { ViewController } from 'foundations-components/transitional/components/ViewController';
import ContentOverview from '../../../components/MostPopularCertificates/ContentOverview';
import { ModalTileSection } from '../../../components/TrackLessonOverviewModal/subcomponents/ModalTileSection';
//@ts-expect-error Could not find declaration file for module
import useMediaQuery from '../../../hooks/useMediaQuery';
import { device } from '../../../constants/StyledComponentConstants';
import { EnrollLessonButton, EnrollShortButton, EnrollTrackButton } from '../../userProgress';
import { Text } from 'foundations-components/components/Text';
import { View } from 'foundations-components/transitional/components/View';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
export const OverviewModalDescriptionSection = ({
  title,
  description,
  duration,
  selectedLanguage,
  availableLanguages,
  availableLanguagesLoading,
  onChangeSelectedLanguage,
  contentList,
  hasCertificate,
  hasStudyGuide,
  type,
  id,
  onEnroll
}) => {
  const isMobile = useMediaQuery(`screen and ${device.mobile}`);
  return /*#__PURE__*/_jsxs(View, {
    children: [/*#__PURE__*/_jsxs(ModalTileSection, {
      children: [/*#__PURE__*/_jsx(Text, {
        as: isMobile ? 'h4' : 'h1',
        marginBlockEnd: "400",
        children: title
      }), type === 'SHORT_FORM_CONTENT' ? /*#__PURE__*/_jsx(EnrollShortButton, {
        id: id || 0,
        onEnroll: onEnroll
      }) : type === 'TRACK' ? /*#__PURE__*/_jsx(EnrollTrackButton, {
        id: id || 0,
        language: selectedLanguage,
        onEnroll: onEnroll
      }) : /*#__PURE__*/_jsx(EnrollLessonButton, {
        id: id || 0,
        language: selectedLanguage,
        onEnroll: onEnroll
      })]
    }), /*#__PURE__*/_jsxs(ModalTileSection, {
      paddingBlockEnd: "600",
      children: [/*#__PURE__*/_jsx(H7, {
        paddingBlockEnd: "200",
        children: duration
      }), description]
    }), (availableLanguages || availableLanguagesLoading) && /*#__PURE__*/_jsx(ModalTileSection, {
      paddingBlockEnd: "400",
      children: /*#__PURE__*/_jsxs("div", {
        children: [/*#__PURE__*/_jsx(H7, {
          children: /*#__PURE__*/_jsx(FormattedMessage, {
            message: "learningCenter.overviewModal.languagesAvailable"
          })
        }), availableLanguagesLoading || !availableLanguages ? /*#__PURE__*/_jsx(LoadingSpinner, {}) : /*#__PURE__*/_jsx(ViewController, {
          "data-test-id": "language-view-controller",
          onChange: onChangeSelectedLanguage,
          options: availableLanguages.map(lang => ({
            text: lang.toUpperCase(),
            value: lang
          })),
          size: "extra-small",
          value: selectedLanguage
        })]
      })
    }), type !== 'SHORT_FORM_CONTENT' && /*#__PURE__*/_jsxs(ModalTileSection, {
      children: [/*#__PURE__*/_jsx(H7, {
        marginBlockEnd: "100",
        marginBlockStart: "300",
        children: /*#__PURE__*/_jsx(FormattedMessage, {
          message: "learningCenter.mostPopularCertificates.includes"
        })
      }), /*#__PURE__*/_jsx(ContentOverview, {
        content: contentList,
        hasCertificate: hasCertificate,
        hasStudyGuide: hasStudyGuide
      })]
    })]
  });
};
export default OverviewModalDescriptionSection;